<template>
  <div v-if="store.NOTARIA" class="n2-raiz n3-raiz" :class="{ 'n3-raiz--inicio': esInicio }" :data-estilo="estilo" :style="variables">
    <!-- Sobre la foto de la portada y de la cabecera de las páginas interiores, la cabecera es transparente -->
    <N3Cabecera :sobre-portada="esInicio || propia" />
    <v-main id="main" class="n3-main" :class="{ 'n2-main--pagina': !esInicio, 'n3-main--pagina n2-main--antigua': !esInicio && !propia }">
      <slot>
        <NuxtPage/>
      </slot>
    </v-main>
    <N3Pie />
  </div>

  <ClientOnly>
    <div id="client-components-wrapper">
      <ElementsButtonUp />
      <Cookies/>
      <ContactSocialChat v-if="store.NOTARIA?.SocialChat?.Show"/>
      <ChatAIChatbot />
      <SolicitudBotonFlotante />
    </div>
  </ClientOnly>
</template>
<script setup>
// Plantilla 3 de notaría, «inmersiva» (ref: https://trello.com/c/MGgrmuPY). Comparte estilos y acento con la plantilla 2
import { computed } from 'vue'
import { useStore } from '../store/index.ts'
import { useNotaria2, FUENTES_ESTILO, paginaConDisenoPropio } from '../composables/useNotaria2'
import N3Cabecera from '../components/notaria3/N3Cabecera.vue'
import N3Pie from '../components/notaria3/N3Pie.vue'
import '../assets/notaria2.scss'
import '../assets/notaria3.scss'

const store = useStore()
// Ruta del router, no useRoute(): en un layout useRoute() espera a que cargue la página
const route = useRouter().currentRoute
const esInicio = computed(() => String(route.value.name || '').replace(/^lang-/, '') === 'index')
// Páginas interiores con el diseño de la plantilla; las demás («antiguas») siguen con los componentes de siempre
const propia = computed(() => paginaConDisenoPropio(route.value.name))
const { estilo, variables } = useNotaria2()

useHead(() => ({
  link: [
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
    { rel: 'stylesheet', href: FUENTES_ESTILO[estilo.value] },
  ],
}))
</script>
